import { VideoPlayerType } from '../../_common/client/types';
import { CliplisterSettings } from './cliplister-settings';
import { ExternalJsLoader } from './external-js-loader';

export type CliplisterViewerQuality = 'S' | 'M' | 'L';

export type CliplisterViewer = {
    onFullscreenChange(param: () => void): void;
    isFullscreen(): boolean;
    onReady(param: () => void): void;
    onPause(param: () => void): void;
    onPlay(param: () => void): void;
    onProgress10(param: () => void): void;
    onProgress50(param: () => void): void;
    onProgress90(param: () => void): void;
    onQualityChange(param: () => void): void;
    getCurrentQuality(): { display: CliplisterViewerQuality };
    play(): void;
    pause(): void;
    getAssets(): { aspectratio: string; duration: number }[];
    getCurrentAssetIndex(): number;
    destroy(): unknown;
};

export type CliplisterViewerClass = {
    new (settings: Record<string, unknown>): CliplisterViewer;
};

declare global {
    interface Window {
        Cliplister?: {
            Viewer: CliplisterViewerClass;
        };
    }
}

export class CliplisterProvider {
    public static libraryLoaded = false;

    public static async getNewViewerInstance(
        assetKey: string,
        parentId: string,
        assetRatioLandscape: boolean,
        videoPlayerType: VideoPlayerType
    ): Promise<CliplisterViewer> {
        if (!CliplisterProvider.libraryLoaded) {
            try {
                await ExternalJsLoader.load(CliplisterSettings.getViewerUrl(videoPlayerType));
                CliplisterProvider.libraryLoaded = true;
            } catch (error) {
                throw new Error(`libraryLoadError, cause: "${error}"`);
            }
        }
        if (window.Cliplister) {
            return new window.Cliplister.Viewer(CliplisterSettings.buildViewerConfig(assetKey, parentId, assetRatioLandscape));
        } else {
            throw new Error('libraryCallError');
        }
    }
}
